/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import { Grid, CardContent, Box } from '@material-ui/core'
import { useQueries } from 'react-query'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import { toast } from 'react-toastify'
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material'
import styled from 'styled-components'
import CustomizedProgress from '../../../customElements/CircularProgress'
import { getMany } from '../../../../services/Api/request'

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  gap: 54px;
  height: 124px;
  width: 100%;

  @media screen and (max-width: 62em) {
    flex-direction: column;
    align-items: center;
    gap: 44px;
    height: auto;
  }
`
export const StyledCardContent = styled(CardContent)`
  width: 100%;

  @media screen and (max-width: 62em) {
    width: auto;
  }
`

export default function ExpeditionInstructionsStep(props) {
  const {
    item,
    setActiveStep,
    funnelState,
    setFunnelState,
    setFunnelSteps,
    step,
  } = props
  const [accesContrainteSelect, setAccesContrainteSelect] = useState(
    funnelState.expeditionContrainteAcces || null
  )
  const [chargementContrainteSelect, setChargementContrainteSelect] = useState(
    funnelState.expeditionContrainteChargement || null
  )
  const [
    { data: accesContraintes, isLoading: isLoadingAcces },
    { data: chargementContraintes, isLoading: isLoadingChargement },
  ] = useQueries([
    {
      queryKey: 'acces_contraintes',
      queryFn: async () => {
        const data = await getMany('acces_contraintes')
        return data
      },
    },
    {
      queryKey: 'chargement_contraintes',
      queryFn: async () => {
        const data = await getMany('chargement_contraintes')
        return data
      },
    },
  ])

  const handleChangeChargementType = (event, value) => {
    setChargementContrainteSelect(value)
  }
  const handleChangeAccesType = (event, value) => {
    setAccesContrainteSelect(value)
  }

  const nextStep = () => {
    if (accesContrainteSelect && chargementContrainteSelect) {
      setFunnelState({
        ...funnelState,
        expeditionContrainteAcces: accesContrainteSelect,
        expeditionContrainteChargement: chargementContrainteSelect,
      })
      setFunnelSteps(step, item)
      setActiveStep(item.nextStep)
    } else {
      toast.error("Veuillez sélectionner des instructions d'expédition")
    }
  }
  const previousStep = () => {
    setFunnelState({
      ...funnelState,
      expeditionContrainteAcces: accesContrainteSelect,
      expeditionContrainteChargement: chargementContrainteSelect,
    })
    setFunnelSteps(step, item)
    setActiveStep(item.previousStep)
  }

  return (
    <div className="card card-funnel">
      <StyledCardContent>
        <Box x={{ flexGrow: 1, margin: 'auto' }} width="100%">
          <Box sx={{ pb: 6 }}>
            <Grid container direction="column">
              <Box sx={{ pb: 2 }}>
                <p>Contraintes d'accès :</p>
              </Box>
              {isLoadingAcces ? (
                <CustomizedProgress />
              ) : (
                <StyledToggleButtonGroup
                  className="toggle-button-group"
                  value={accesContrainteSelect}
                  exclusive
                  onChange={handleChangeAccesType}
                >
                  {accesContraintes.map((acces) => (
                    <ToggleButton
                      className={`toggle-btn ${
                        accesContrainteSelect?.id === acces.id ? ' select ' : ''
                      }`}
                      key={acces.id}
                      active={acces}
                      value={acces}
                      style={{ position: 'relative' }}
                    >
                      <img
                        src={`/icons/funnel/cotation/${acces.icon}`}
                        alt="svg"
                        className="svgIcon"
                      />
                      <Box
                        className="title-toggle-btn"
                        style={{
                          position: 'absolute',
                          width: '100%',
                          top: 'calc(100% + 10px)',
                        }}
                      >
                        {acces.nom}
                      </Box>
                    </ToggleButton>
                  ))}
                </StyledToggleButtonGroup>
              )}
            </Grid>
          </Box>
          <Box sx={{ py: 1 }}>
            <Grid container direction="column">
              <Box sx={{ pb: 2 }}>
                <p>Contraintes de chargement :</p>
              </Box>
              {isLoadingChargement ? (
                <CustomizedProgress />
              ) : (
                <StyledToggleButtonGroup
                  className="toggle-button-group"
                  value={chargementContrainteSelect}
                  exclusive
                  onChange={handleChangeChargementType}
                >
                  {chargementContraintes.map((chargement) => (
                    <ToggleButton
                      className={`toggle-btn ${
                        chargementContrainteSelect?.id === chargement.id
                          ? ' select '
                          : ''
                      }`}
                      key={chargement.id}
                      active={chargement}
                      value={chargement}
                      style={{ position: 'relative' }}
                    >
                      <img
                        src={`/icons/funnel/cotation/${chargement.icon}`}
                        alt="svg"
                        className="svgIcon"
                      />
                      <Box
                        className="title-toggle-btn"
                        style={{
                          position: 'absolute',
                          width: '100%',
                          top: 'calc(100% + 10px)',
                        }}
                      >
                        {chargement.nom}
                      </Box>
                    </ToggleButton>
                  ))}
                </StyledToggleButtonGroup>
              )}
            </Grid>
          </Box>
        </Box>
      </StyledCardContent>

      <Tooltip title="Précédent" placement="right">
        <button
          type="button"
          className="btn-funnel"
          style={{
            bottom: '2rem',
            left: '2rem',
          }}
          onClick={previousStep}
        >
          <NavigateBeforeIcon />
        </button>
      </Tooltip>
      <Tooltip title="Suivant" placement="left">
        <button
          type="button"
          className="btn-funnel"
          style={{
            bottom: '2rem',
            right: '2rem',
          }}
          onClick={nextStep}
        >
          <NavigateNextIcon />
        </button>
      </Tooltip>
    </div>
  )
}
